/* global
 BMap,
 BMapLib,
 BMAP_POINT_SIZE_BIG, BMAP_POINT_SIZE_SMALL,BMAP_NAVIGATION_CONTROL_LARGE,BMAP_ANCHOR_TOP_RIGHT,BMAP_POINT_SIZE_BIGGER,BMAP_POINT_SIZE_HUGE
 BMAP_POINT_SIZE_NORMAL BMAP_POINT_SHAPE_CIRCLE, BMAP_POINT_SHAPE_RHOMBUS BMAP_POINT_SHAPE_STAR
*/
import { pointsInRect, areSamePoints, distinctPoints } from '../utils/helpers';
import store from '@/store';
const CHINA_CENTER = new BMap.Point(113.216596, 22.913121);

const createIsMouseOverPoint = (mousePoint, radius) => {
    const circle = new BMap.Circle(mousePoint, radius); // 创建圆形覆盖物对象
    return (point) => {
        return BMapLib.GeoUtils.isPointInCircle(point, circle); // 判断点是否在指定的圆形区域内
    };
};

export class MapController {
    mapId;
    map;
    drawingManager;
    isPolyline = false; // 默认路径

    _callbacks = new Map();
    routes = new Map();
    overlays = new Map();
    drivings = new Map();
    candwPoint = new Set();
    pointLabel = new Set();
    // 保存地图上画出的所有坐标，用于适配地图缩放 viewport
    viewportPoints = new Map();
    eventListener = new Map();
    selectId = new Map()
    
    polygonOverlays = []; // 多边形覆盖物数组
    polygonPoints = []; // 当前正在绘制的多边形顶点数组
    isDrawingPolygon = false; // 是否正在绘制多边形

    listen(eventName, callback) {
        this._callbacks.set(eventName, callback);
    }
    unlisten(eventName) {
        this._callbacks.delete(eventName);
    }
    clearListeners() {
        this._callbacks.clear();
    }
    fire(eventName, payload) {
        if (this._callbacks.has(eventName)) {
            this._callbacks.get(eventName)(payload);
        }
    }

    constructor(mapId, { isPolyline = false }) {
        this.mapId = mapId;
        this.isPolyline = isPolyline;
    }

    clearResults (driving) {
        driving.clearResults();
    }

    // 初始化地图
    initMap() {
        const map = new BMap.Map(this.mapId, { enableMapClick: false });
        this.map = map;
        map.centerAndZoom(CHINA_CENTER, 6);
        map.enableScrollWheelZoom(true);
        map.setMaxZoom(20);
        map.disableDoubleClickZoom();
        const navigationControl = new BMap.NavigationControl({
            offset: new BMap.Size(3, 3),
            anchor: BMAP_ANCHOR_TOP_RIGHT,
            type: BMAP_NAVIGATION_CONTROL_LARGE
        });
        map.addControl(navigationControl);
        // 监听地图移动和缩放事件
        map.addEventListener('moveend', e => {
            this.fire('moveend-or-zoomend', e);
        });
        map.addEventListener('zoomend', e => {
            this.fire('moveend-or-zoomend', e);
        });

        // 地图点选货框选触发
        this.createDrawingManager();
        // 监听鼠标点击
        this.listenMouseDownAndUp();

        return map;
    }
    // 点选切换
    switchDrawingMode(drawing) {
        if (drawing === 2) {
            // 矩形
            this.clearAllPolygons();
            this.drawingManager.enableDrawing();
        } else if (drawing === 3) {
            // 多边形
            this.drawingManager.polygonDrawing();
        } else {
            // 点
            this.clearAllPolygons();
            this.drawingManager.disableDrawing();
        }
    }
    // 切换直线/路径模式
    switchPolylineMode (isPolyline) {
        if (this.isPolyline !== isPolyline) {
            this.isPolyline = isPolyline;
            // 重绘所有路径
            for (const [id, params] of this.routes.entries()) {
                this.addRoute(id, params.start, params.points, params.loadData, params.options);
            }
        }
    }
    // 画路径  loadData TK单信息
    addRoute (id, start, Points, loadData, options = { color: '#0000FF' }) {
        // 去掉无效点
        const points = Points.filter(p => p && p.lng && p.lat);
        // 清空id对应的覆盖物和驾车导航路径
        this._removeOverlays(id);
        this._removeDrivings(id);

        const overlays = [];
        const drivings = [];
        // 添加折线
        const polylinePoints = [start].filter(p => p && p.lng && p.lat).concat(points);
        if (polylinePoints.length > 1) {
            if (this.isPolyline) {
                // 画直线
                this._drawPolyline(id, polylinePoints, options, overlays);
            } else {
                // 画折线路径
                this._drawGuideLine(id, polylinePoints, options, overlays, drivings);
            }
        }
        // 存数据 避免在切换模式找不到数据
        this.overlays.set('loadData', loadData);
        const getTaskInfos = this.overlays.get('loadData') || [];
        // 添加地点文本标注
        for (const [idx, p] of getTaskInfos.entries()) {
            // 创建文本标注对象
            const label = new BMap.Label(idx === 0 ? '起' : String(`${idx}`), {
                position: new BMap.Point(p.longitude, p.latitude),
                offset: new BMap.Size(-10, -10)
            });
            // 自定义文本标注样式
            label.setStyle({
                color: 'white',
                backgroundColor: options.color,
                fontSize: '16px',
                border: '2px solid white',
                borderRadius: '50%',
                height: '20px',
                width: '20px',
                lineHeight: '20px',
                textAlign: 'center',
                fontFamily: '微软雅黑'
            });
            overlays.push(label);
            // 添加信息弹框  收货地不显示订单信息
            if (p.transportList && p.transportList.length) {
                const content = `
                <style  scoped>
                        table {
                            border-collapse: collapse;
                            width: 100%;
                            margin-top: 0.8rem;
                            font-size: 0.9rem;
                            table-layout: fixed;
                            word-wrap: break-word;
                        }
                        tr {
                            border-bottom: 0.1rem solid rgb(241, 238, 238);
                            line-height: 1rem;
                            }
                        th, td {
                            text-align: left;
                            padding: 2px;
                        }
                        th {
                            background-color: #f2f2f2;
                        }
                        </style>
                          <div style="max-height: 300px; overflow-y: auto;">  <table>
                                <thead>
                                <tr style="background-color: rgba(242, 242, 242, 0.8);">
                                    <th>客户订单号</th>
                                    <th>件数</th>
                                    <th>重量(Kg)</th>
                                    <th>体积(m³)</th>
                                    <th style="width:120px">收货详细地址</th>
                                    <th>备注</th>
                                    <th>收货人</th>
                                    <th style="width:120px">收货人联系方式</th>
                                </tr>
                                </thead>
                                <tbody>
                                ${p.transportList.map(row => `
                                    <tr>
                                    <td>${row.customerOrderNo}</td>
                                    <td>${row.totalQty}</td>
                                    <td>${row.totalNetWeight}</td>
                                    <td>${row.totalVolume}</td>
                                    <td>${row.receiverDetailAddr}</td>
                                    <td>${row.remark}</td>
                                    <td>${row.receiverName}</td>
                                    <td>${row.receiverTel}</td>
                                    </tr>
                                `).join('')}
                                </tbody>
                            </table></div>
                            `;

                this.addClickHandler(this.map, {
                    label,
                    content,
                    point: new BMap.Point(p.longitude, p.latitude)
                });
            }
        }
        this._addOverlays(id, overlays);
        this._addDrivings(id, drivings);
        this._expandViewport(id, polylinePoints);
        this.routes.set(id, {
            start,
            points,
            loadData,
            options
        });
    }
    addClickHandler (map, { label, content, point }) {
        label.addEventListener('click', function () {
            const infoWindow = new BMap.InfoWindow(content, {
                title: '订单明细',
                width: 730, // 最大宽度
                height: 0 // 自适应
            });
            map.openInfoWindow(infoWindow, point); // 开启信息窗口
        });
    }
    // 画直线折线 绘制折线的地图叠加层polyline
    _drawPolyline (id, points, options, overlays) {
        // 画直线
        const route = new BMap.Polyline(
            points.map(p => new BMap.Point(p.lng, p.lat)),

            { strokeColor: options.color, strokeWeight: 5, strokeOpacity: 1 }
        );
        overlays.push(route);
    }

    // 使用百度地图的驾车导航功能画路径
    _drawGuideLine (id, points, options, overlays, drivings) {
        // 只绘制坐标有效的点
        for (const [idx, p] of points.slice(1).entries()) {
            const p1 = new BMap.Point(points[idx].lng, points[idx].lat);
            const p2 = new BMap.Point(p.lng, p.lat);

            if (p1.lng !== p2.lng || p1.lat !== p2.lat) {
                const driving = memoDrivingRoute(this.map, p1, p2,id,this, (polyline, memoPoints) => {
                    if (polyline) {
                        polyline.setStrokeColor(options.color);
                        polyline.setStrokeOpacity(1);
                        overlays.push(polyline);
                        this.overlays.set(id, overlays);
                    } else {
                        this._drawPolyline(id, memoPoints, options, overlays);
                    }
                });
                driving && drivings.push(driving);
            }
        }
    }

    // 清除路径
    removeRoute (id) {
        this._removeOverlays(id);
        this._removeDrivings(id);
        this._shrinkViewport(id);
        this.routes.delete(id);
    }

    // 清除所有路径
    removeAllRoutes() {
        for (const id of this.routes.keys()) {
            this.removeRoute(id);
        }
    }

    removeCandw (id) {
        this._removeOverlays(id);
        this.candwPoint.delete(id);
    }
    removeLabel (id) {
        this._removeOverlays(id);
        this.pointLabel.delete(id);
    }

    // 清除客户仓库图标
    removecandwPoitn() {
        for (const id of this.candwPoint.keys()) {
            this.removeCandw(id);
        }
    }
    // 清除坐标label
    removecandwLabel() {
        for (const id of this.pointLabel.keys()) {
            this.removeLabel(id);
        }
    }
    // 存数据
    _addOverlays(id, overlays) {
        for (const ol of overlays) {
            this.map.addOverlay(ol);
        }
        this.overlays.set(id, overlays);
    }
    // 覆盖物清除方式 当图层嵌套多 不能使用一次性清除 考虑ID清除
    _removeOverlays(id) {
        const overlays = this.overlays.get(id);
        if (Array.isArray(overlays)) {
            for (const ol of overlays) {
                this.map.removeOverlay(ol);
            }
        } else if (overlays) {
            this.map.removeOverlay(overlays);
        }
        this.overlays.delete(id);
    }

    _addDrivings(id, drivings) {
        this.drivings.set(id, drivings);
    }

    _removeDrivings(id) {
        const drivings = this.drivings.get(id);
        if (Array.isArray(drivings)) {
            for (const driving of drivings) {
                driving && driving.clearResults();
            }
        } else if (drivings) {
            drivings && drivings.clearResults();
        }
        this.drivings.delete(id);
    }

    _expandViewport(id, points) {
        this.viewportPoints.set(id, points);
        this._setViewport();
    }

    _shrinkViewport(id) {
        this.viewportPoints.delete(id);
        this._setViewport();
    }

    _setViewport() {
        const allVP = [];
        for (const ps of this.viewportPoints.values()) {
            allVP.push(...ps);
        }
        this.map.setViewport(allVP.filter(p => p && p.lng && p.lat));
    }

    allPoints = [];
    pointCollectionList = [];
    // selectMode: "none" | "temp" | "select" | 'other'
    _createPointCollection (points, color, selectMode = 'none',pointInfo) {
        // 图标配置
        const options = {
            size: {
                none: BMAP_POINT_SIZE_BIG,
                temp: BMAP_POINT_SIZE_SMALL,
                select: BMAP_POINT_SIZE_NORMAL,
                other: BMAP_POINT_SIZE_BIGGER
            }[selectMode],
            shape: {
                none: BMAP_POINT_SHAPE_CIRCLE,
                temp: BMAP_POINT_SHAPE_RHOMBUS,
                select: BMAP_POINT_SHAPE_STAR,
                other: BMAP_POINT_SHAPE_RHOMBUS
            }[selectMode],
            color
        };
        const Boptions = {
            size: {
                none: BMAP_POINT_SIZE_HUGE,
                temp: BMAP_POINT_SIZE_SMALL,
                select: BMAP_POINT_SIZE_BIG,
                other: BMAP_POINT_SIZE_BIGGER
            }[selectMode],
            shape: {
                none: BMAP_POINT_SHAPE_CIRCLE,
                temp: BMAP_POINT_SHAPE_RHOMBUS,
                select: BMAP_POINT_SHAPE_STAR,
                other: BMAP_POINT_SHAPE_RHOMBUS
            }[selectMode],
            color
        };
        const key = 'circleSize';
        const collections = [];
        const specialPoints = [];
        const normalPoints = [];
        let BigPointList = [];
        const userCode = store.state.user.userCode;
        const accountInfoStr = localStorage.getItem(key);
        // 获取userCode数据，和浏览器存储中的数据对比，符合条件的推进BigPointList
        if (pointInfo && pointInfo.length) {
            BigPointList = pointInfo.filter(itm => {
                if (accountInfoStr) {
                    const accountInfo = JSON.parse(accountInfoStr);
                    const userData = accountInfo[userCode];
                    if (!userData) return false;
                    return ((+itm.totalVolume >= userData.totalVolume && +userData.totalVolume) || (+itm.totalPackageQuantity >= userData.totalPackageQuantity && +userData.totalPackageQuantity)
                    );
                }
                return false;
            });
        }

        // 区分收货地的点还是发货地的点
        points.forEach(itm => {
            const isSpecial = BigPointList.some(item => {
                if (item.inOutType === 'IN') {
                    return +item.startLat === +itm.lat && +item.startLng === +itm.lng;
                } else {
                    return +item.endLat === +itm.lat && +item.endLng === +itm.lng;
                }
            });
            if (isSpecial) {
                specialPoints.push(itm);
            } else {
                normalPoints.push(itm);
            }
        });

        // 2. 分别创建 PointCollection,区分大圆和小圆
        if (normalPoints.length) {
            var normalCollection = new BMap.PointCollection(normalPoints, options);
            this.map.addOverlay(normalCollection);
            if (selectMode === 'none') {
                normalCollection.addEventListener('mouseover', (event) => {
                    this.fire('point-mouseover', event);
                });
                normalCollection.addEventListener('mouseout', (event) => {
                    this.fire('point-mouseout', event);
                });
            }
            if (selectMode === 'none' || selectMode === 'other') {
                this.pointCollectionList.push(normalCollection);
            }
            collections.push(normalCollection);
        }
        if (specialPoints.length) {
            var specialCollection = new BMap.PointCollection(specialPoints, Boptions);
            this.map.addOverlay(specialCollection);
            if (selectMode === 'none') {
                specialCollection.addEventListener('mouseover', (event) => {
                    this.fire('point-mouseover', event);
                });
                specialCollection.addEventListener('mouseout', (event) => {
                    this.fire('point-mouseout', event);
                });
            }
            if (selectMode === 'none' || selectMode === 'other') {
                this.pointCollectionList.push(specialCollection);
            }
            collections.push(specialCollection);
        }
        return collections;
    }

    // 点圈选触发
    createDrawingManager() {
        let selectedPoints = []; // 选中的点
        this.drawingManager = new DrawingManager(this.map,this); // 绘制多边形覆盖物
        this.drawingManager.onDrawingSizeChange(({ point1, point2 }) => {
            const latMin = Math.min(point1.lat, point2.lat);
            const latMax = Math.max(point1.lat, point2.lat);
            const lngMin = Math.min(point1.lng, point2.lng);
            const lngMax = Math.max(point1.lng, point2.lng);

            //  在同长方形中的点
            const points = pointsInRect(latMin, lngMin, latMax, lngMax, this.allPoints);
            // 判断两个点数组是否包含相同的点
            if (!areSamePoints(selectedPoints, points)) {
                selectedPoints = points;
                this.fire('points-selected-preview', { points: selectedPoints });
            }
        });

        //  监听圈选完事件
        this.drawingManager.onDrawingDone(({ point1, point2 }) => {
            this.fire('points-selected', { points: selectedPoints, from: 'drawing' });
            selectedPoints = [];
        });
    }

    // 鼠标点击抬起
    listenMouseDownAndUp () {
        let clickedPoints = [];
        let eventPoint = new BMap.Point(0, 0);
        this.map.addEventListener('mousedown', (event) => {
            const point = event.point;
            // 像素坐标转为经纬度
            const point2 = this.map.pixelToPoint(new BMap.Pixel(event.pixel.x + 1000 * 1000, event.pixel.y));
            const radius = Math.abs(point.lng - point2.lng); // 返回绝对值
            const isMouseOverPoint = createIsMouseOverPoint(event.point, radius); // 创建覆盖物圆点
            clickedPoints = this.allPoints.filter(p => isMouseOverPoint(p));
            if (clickedPoints.length > 0) {
                eventPoint = event.point;
            }
        });
        this.map.addEventListener('mouseup', (event) => {
            if (eventPoint.lng === event.point.lng && eventPoint.lat === event.point.lat) {
                this.fire('points-selected', { points: clickedPoints, from: 'click' });
            }
        });
    }
    // 绘制地图打点
    drawPoints (points, pointList, pointInfo) {
        this.allPoints = points;
        this.pointCollectionList.forEach(pointCollectionPoint => {
            pointCollectionPoint.clear();
        });
        this.pointCollectionList = [];
        const color = ['red', 'blue', 'green', 'cyan', 'purple', '#ED64A6', 'black', '#fa7507', '#f3c10a', '#38B2AC'];
        pointList.forEach((points, index) => {
            if (points[0] && points[0].length) {
                this._createPointCollection(points[0], color[index], 'none', pointInfo);
            }
            if (points[1] && points[1].length) {
                this._createPointCollection(points[1], color[index], 'other', pointInfo);
            }
        });
        // 调整视野
        const allPoints = distinctPoints(this.allPoints.concat(this.selected).filter(p => p));
        if (allPoints.length === 0) {
            this.map.centerAndZoom(CHINA_CENTER, 6);
        } else if (allPoints.length === 1) {
            this.map.centerAndZoom(allPoints[0], 6);
        } else {
            this.map.setViewport(allPoints); // 最佳视野
        }
    }
    // 单独给label
    markLabel (id, points) {
        const overlays = [];
        // 去重经纬度并合并相同坐标点的totalPackageQuantity
        const allPoints = points.map(itm => {
            if (itm.inOutType === 'IN') {
                return { lng: itm.startLng, lat: itm.startLat, totalPackageQuantity: itm.totalPackageQuantity, totalVolume: itm.totalVolume };
            } else {
                return { lng: itm.endLng, lat: itm.endLat, totalPackageQuantity: itm.totalPackageQuantity, totalVolume: itm.totalVolume };
            }
        });

        // 使用Map来合并相同坐标点的数据
        const pointMap = new Map();
        allPoints.forEach(point => {
            const key = `${point.lng},${point.lat}`;
            if (pointMap.has(key)) {
                // 如果已存在相同坐标点，累加
                const existingPoint = pointMap.get(key);
                existingPoint.totalPackageQuantity += (point.totalPackageQuantity || 0);
                const totalVolumePoint = pointMap.get(key);
                totalVolumePoint.totalVolume += (point.totalVolume || 0);
            } else {
                // 如果是新的坐标点，直接添加
                pointMap.set(key, { ...point });
            }
        });

        const newpoints = Array.from(pointMap.values());

        newpoints.forEach((point, idx) => {
            const mapPoint = new BMap.Point(point.endLng || point.lng, point.endLat || point.lat);
            const labelText = point.totalPackageQuantity? Math.round(Number(point.totalPackageQuantity) * 100) / 100: 0; // 显示累加后的包装数
            const label = new BMap.Label(labelText, {
                position: mapPoint,
                offset: new BMap.Size(-15, -25)
            });
            // 自定义文本标注样式
            label.setStyle({
                color: 'white',
                fontSize: '12px',
                borderColor: 'rgba(0, 0, 0, 0.6)',
                backgroundColor: 'rgba(0, 0, 0, 0.6)',
                padding: '0px 10px',
                borderRadius: '10px'
            });
            overlays.push(label);
        });

        // 记录overlays
        this._addOverlays(id, overlays);

        this.pointLabel.add(id);
    }
    // 客户 仓库单独打点addOverlay
    markPoints (id, points) {
        const overlays = [];
        points.forEach((point) => {
            const mapPoint = new BMap.Point(point.endLng || point.lng, point.endLat || point.lat);
            const wIcon = new BMap.Icon(
                require('./warehouse.png'),
                new BMap.Size(37, 55)
            );
            if (point.flag === 'warehouse') {
                const marker = new BMap.Marker(mapPoint, { icon: wIcon });
                overlays.push(marker);
                this.map.addOverlay(marker);
            }
        });
        // 记录overlays
        this._addOverlays(id, overlays);

        this.candwPoint.add(id);
    }

    seleted = [];
    selectedPointCollection;

     // 绘制点
     drawSelectedPoints (selectedPoints, tempSelectedPoints) {
        if (this.selectedPointCollection) {
            (Array.isArray(this.selectedPointCollection) ? this.selectedPointCollection : [this.selectedPointCollection])
                .forEach(collection => {
                    this.map.removeOverlay(collection);
                });
            this.selectedPointCollection = null;
        }

        // 只有当有选中点时才创建新的集合
        if (selectedPoints && selectedPoints.length > 0) {
            this.selectedPointCollection = this._createPointCollection(selectedPoints, 'yellow', 'select');
        }
    }

     // 清理选中的点集合
    clearSelectedPoints() {
        if (this.selectedPointCollection) {
            (Array.isArray(this.selectedPointCollection) ? this.selectedPointCollection : [this.selectedPointCollection])
                .forEach(collection => {
                    this.map.removeOverlay(collection);
                });
            this.selectedPointCollection = null;
        }
    }

    // 一次性移除覆盖物
    clearOverlays() {
        this.map.clearOverlays();
    }

    // 经纬度坐标转换为像素坐标
    pointToxPixel(point) {
        return this.map.pointToPixel(point);
    }

    //  将逻辑类文件整合到地图控制文件中
    mapLogic = null;
    useLogic (logic, configLogic) {
        this.mapLogic = logic;
        configLogic(this, logic);
    }

    run (fn) {
        fn(this, this.mapLogic);
    }

    onMoveOrZoom(callback) {
        this.listen('moveend-or-zoomend', callback);
    }

    onSelectPointsPreview(callback) {
        this.listen('points-selected-preview', callback);
    }

    // 选中逻辑
    onSelectPoints(callback) {
        this.listen('points-selected', callback);
    }

    onPointMouseover(callback) {
        this.listen('point-mouseover', callback);
    }
    onPointMouseout(callback) {
        this.listen('point-mouseout', callback);
    }

    // 开始绘制多边形
    startDrawPolygon () {
        this.isDrawingPolygon = true;
        this.polygonPoints = [];
        this.lastClickTime = null;
        this.map.setDefaultCursor('pointer');
        this.map.disableDragging();

        // 添加鼠标点击事件监听
        this.map.addEventListener('mousedown', this.handlePolygonClick);
        this.map.addEventListener('mousemove', this.handlePolygonMouseMove);
    }

    // 处理多边形点击事件
    handlePolygonClick = (e) => {
        if (!this.isDrawingPolygon) return;

        // 检查是否是双击的一部分
        const now = Date.now();
        if (this.lastClickTime && now - this.lastClickTime < 300) {
            // 如果是双击，触发完成绘制
            this.finishDrawPolygon(e);
            this.lastClickTime = null;
            return;
        }
        this.lastClickTime = now;

        const point = e.point;
        this.polygonPoints.push(point);

        // 更新多边形显示
        this.updatePolygonOverlay();
    }

    // 处理鼠标移动事件
    handlePolygonMouseMove = (e) => {
        if (!this.isDrawingPolygon || this.polygonPoints.length === 0) return;

        // 创建临时点数组，包含已有点和当前鼠标位置
        const tempPoints = [...this.polygonPoints, e.point];

        // 更新临时多边形显示
        if (this.polygonOverlay) {
            this.map.removeOverlay(this.polygonOverlay);
        }

        this.polygonOverlay = new BMap.Polygon(tempPoints, {
            strokeColor: '#ff0000',
            strokeWeight: 2,
            strokeOpacity: 0.8,
            fillColor: '#ffffff',
            fillOpacity: 0.4
        });

        this.map.addOverlay(this.polygonOverlay);
    }

    // 完成多边形绘制
    finishDrawPolygon = (e) => {
        if (!this.isDrawingPolygon || this.polygonPoints.length < 3) {
            this.cancelDrawPolygon();
            return;
        }

        // 先清除临时多边形
        if (this.polygonOverlay) {
            this.map.removeOverlay(this.polygonOverlay);
            this.polygonOverlay = null;
        }

        // 创建新的多边形覆盖物
        const newPolygon = new BMap.Polygon(this.polygonPoints, {
            strokeColor: '#ff0000',
            strokeWeight: 2,
            strokeOpacity: 0.8,
            fillColor: '#ffffff',
            fillOpacity: 0.6
        });

        // 添加到地图和数组
        this.map.addOverlay(newPolygon);

        this.polygonOverlays.push(newPolygon);

        // 获取所有多边形内的点
        const pointsInPolygons = this.getPointsInPolygons(newPolygon);
        if (pointsInPolygons.length) {
            // 触发选择事件
            this.fire('points-selected', {
                points: pointsInPolygons,
                from: 'polygon'
            });
        }
        // 清理当前绘制状态，准备绘制下一个多边形
        this.polygonPoints = [];
        this.isDrawingPolygon = true;
    }

    // 取消多边形绘制
    cancelDrawPolygon () {
        if (this.polygonOverlay) {
            this.map.removeOverlay(this.polygonOverlay);
            this.polygonOverlay = null;
        }

        this.polygonPoints = [];
        // 保持绘制模式，不设置 isDrawingPolygon = false
    }

    // 清除所有多边形
    clearAllPolygons (flag) {
        // 清除所有多边形覆盖物
        this.polygonOverlays.forEach(overlay => {
            this.map.removeOverlay(overlay);
        });
        this.polygonOverlays = [];

        // 清除当前正在绘制的多边形
        if (this.polygonOverlay) {
            this.map.removeOverlay(this.polygonOverlay);
            this.polygonOverlay = null;
        }

        // 添加flag标识判断是否来源切换模式还是只是清空
        if (!flag) {         
            this.polygonPoints = [];
            this.isDrawingPolygon = false;
            this.lastClickTime = null;
    
            // 移除事件监听
            this.map.removeEventListener('mousedown', this.handlePolygonClick);
            this.map.removeEventListener('mousemove', this.handlePolygonMouseMove);
    
            // 恢复地图状态
            this.map.setDefaultCursor('default');
            this.map.enableDragging();
        }
    }

    // 获取当前绘制多边形内的点
    getPointsInPolygons (newPolygon) {
        if (newPolygon.length === 0) {
            return [];
        }

        // 只返回当前多边形内的点
        return this.allPoints.filter(point => {
            return BMapLib.GeoUtils.isPointInPolygon(point, newPolygon);
        });
    }

    // 更新多边形覆盖物
    updatePolygonOverlay () {
        if (this.polygonOverlay) {
            this.map.removeOverlay(this.polygonOverlay);
        }

        if (this.polygonPoints.length >= 3) {
            this.polygonOverlay = new BMap.Polygon(this.polygonPoints, {
                strokeColor: '#ff0000',
                strokeWeight: 2,
                strokeOpacity: 0.8,
                fillColor: '#ffffff',
                fillOpacity: 0.4
            });
            this.map.addOverlay(this.polygonOverlay);
        }
    }
}
/// 记忆 百度地图的驾车导航功能画路径
/// 避免重复调用 driving 的 search 接口，提高路径绘制速度
const memoDrivingRoute = (() => {
    const memo = new Map();

    return (map, p1, p2, id, that, resultCallback) => {
        const key = `${p1.lng}-${p1.lat}--${p2.lng}-${p2.lat}`;

        if (memo.has(key)) {
            return resultCallback(null, memo.get(key));
        }
        // 获取驾车路线规划 DrivingRoute
        const driving = new BMap.DrivingRoute(map, {
            // 结果呈现
            renderOptions: {
                map: map,
                autoViewport: false
            },
            // 起点目的点
            onMarkersSet: (pos) => {
                map.removeOverlay(pos[0].marker);
                map.removeOverlay(pos[1].marker);
            },
            // 折线添加后回调   routes  沿途坐标点
            onPolylinesSet: (routes) => {
                if (routes.length >= 1) {
                    let removeAllRoutes = null;
                    const selectedArray = Array.from(that.selectId.values());
                    if (!selectedArray.includes(id)) {
                        removeAllRoutes = routes;
                    } else {
                        removeAllRoutes = routes.slice(1);
                    }
                   
                    for (const route of removeAllRoutes) {
                        map.removeOverlay(Array.isArray(route.getPolyline()) ? route.getPolyline()[0] : route.getPolyline());
                    }

                    const route = routes[0];

                    const polyline = Array.isArray(route.getPolyline()) ? route.getPolyline()[0] : route.getPolyline();
                    // 注意沿途覆盖点取值 确保能规划路线 谷歌、Edge 取值不同
                    resultCallback(polyline,  route.Pr || route.Er);
                    memo.set(key,  route.Pr || route.Er);
                }
            }
        });
        driving.search(p1, p2);
        return driving;
    };
})();

// 点圈选类
class DrawingManager {
    isDragging = 1;
    map = null;
    mapController = null; // 添加MapController引用
    _defaultCursor;
    _defaultDraggingCursor;

    _overlay = null;

    _callbacks = new Map();
    listen(eventName, callback) {
        this._callbacks.set(eventName, callback);
    }
    unlisten() {
        this._callbacks.clear();
    }
    fire(eventName, payload) {
        if (this._callbacks.has(eventName)) {
            this._callbacks.get(eventName)(payload);
        }
    }

    _setdownDrawing = () => {};

    _overlayOptions = {
        strokeWeight: 1,
        strokeColor: '#ff0000cc',
        fillColor: '#cc0000',
        fillOpacity: 0.15
    };

    constructor(map,mapController) {
        this.map = map;
        this.mapController = mapController; // 保存MapController引用
        this._defaultCursor = map.getDefaultCursor(); // 返回地图默认的鼠标指针样式
        this._defaultDraggingCursor = map.getDraggingCursor(); // 返回拖拽地图时的鼠标指针样式

        this.setupDrawing();
    }

    // 启用绘制方形
    enableDrawing() {
        this.isDragging = 2;
        this.map.setDefaultCursor('crosshair');
        this.map.setDraggingCursor('crosshair');
        this.map.disableDragging();
    }

     // 启用多边形
     polygonDrawing() {
        this.isDragging = 3;
        this.map.disableDragging();
        this.mapController.startDrawPolygon();
    }

    disableDrawing() {
        this.isDragging = 1;
        this.map.setDefaultCursor(this._defaultCursor); // 设置鼠标为 + 字
        this.map.setDraggingCursor(this._defaultDraggingCursor); // 设置拖拽鼠标样式
        this.map.enableDragging();
    }

    onDrawingSizeChange(callback) {
        this.listen('drawing-size-change', callback);
    }

    onDrawingDone(callback) {
        this.listen('drawing-done', callback);
    }

    setupDrawing() {
        let isDrawing = false;
        let pDown;
        const drawRect = (p1, p2) => {
            if (isDrawing) {
                this._overlay && this.map.removeOverlay(this._overlay);// 绘制方形，存在则清除再更新
                this.drawRect(p1, p2);
            }
        };
        const onMD = (event) => {
            // 鼠标按下
            if (this.isDragging === 2) { // 鼠标按下判断是否启用绘制方形
                isDrawing = true;
                pDown = event.point;
            }
        };
        const onMM = (event) => {
            // 鼠标移动
            if (isDrawing) {
                drawRect(pDown, event.point);
                this.fire('drawing-size-change', { point1: pDown, point2: event.point });
            }
        };
        const onMU = (event) => {
            // 鼠标抬起
            if (isDrawing && (pDown.lng !== event.point.lng && pDown.lat !== event.point.lat)) {
                this.map.removeOverlay(this._overlay);
                this.fire('drawing-done', { point1: pDown, point2: event.point });
            }
            isDrawing = false;
        };

        this.map.addEventListener('mousedown', onMD);
        this.map.addEventListener('mousemove', onMM);
        this.map.addEventListener('mouseup', onMU);
    }

    drawRect(p1, p2) {
        const points = [
            p1,
            new BMap.Point(p1.lng, p2.lat),
            p2,
            new BMap.Point(p2.lng, p1.lat)
        ];
        this._overlay = new BMap.Polygon(points, this._overlayOptions); // 多边形覆盖物
        this.map.addOverlay(this._overlay);
    }
}
